export const sellerPayoutStatementsPath = "/seller-payout-statements";

export const sellerPayoutStatementsUrl = () => sellerPayoutStatementsPath;
